// extracted by mini-css-extract-plugin
export default {"item":"spotInstructionAttachments_item__ujZho","view":"spotInstructionAttachments_view__aYbzz"};